import { render, staticRenderFns } from "./capacity-fixed.vue?vue&type=template&id=4b07a34d&scoped=true&"
import script from "./capacity-fixed.vue?vue&type=script&lang=js&"
export * from "./capacity-fixed.vue?vue&type=script&lang=js&"
import style0 from "./capacity-fixed.vue?vue&type=style&index=0&id=4b07a34d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b07a34d",
  null
  
)

export default component.exports